<template>
  <div class="teasonlinesignupcustomfrom-div">
    <!-- <component :is="'1'">
    </component> -->
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileTeasOnlineSignUpCustomFrom",
  mixins: [$mixins.control],
  ctrlCaption: "网报自定义表单",
  design: {
    isMask: false,
  },
  props: {
    // sourcesUrl: {
    //   type: String,
    //   default: "teas/checkManagement/getRegisterInfo",
    // },
  },
  data() {
    return {
      viewData: {},
      pageLayoutData: [],
    };
  },
  created() {
    this.loadCurrentPageForm();
  },
  methods: {
    loadCurrentPageForm() {
      const loading = dsf.layer.loading();
      this.$http
        .get("rm/list/meta", {
          namespace: "teas.jwgl.bjxygl",
        })
        .done((res) => {
          dsf.layer.closeLoading(loading);
          if (res.success && res.state == 20000 && res.data) {
            let tempObject = {};
            res.data.forEach((item) => {
              if (item.code == "bjxygl") {
                tempObject = item.metadata;
              }
            });
            this.configLayoutData(tempObject);
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "出错了，请重试", false);
        });
    },
    configLayoutData(layoutData) {
      console.log(layoutData);
      Object.keys(layoutData).forEach((item) => {
        if (
          layoutData[item].defaultValue &&
          layoutData[item].defaultValue.length > 0
        ) {
          let tempString = layoutData[item].defaultValue;
          if (this.isJSON(tempString)) {
            this.viewData[item] = JSON.parse(tempString);
          } else {
            this.viewData[item] = tempString;
          }
        } else {
          this.viewData[item] = layoutData[item].defaultValue;
        }
        if(layoutData[item].controls && layoutData[item].controls.length > 0){
          let tempLayoutName = layoutData[item].controls[0].value;
          if(tempLayoutName.indexOf("mobile.") > -1){
            tempLayoutName = tempLayoutName.replace(/\./g , "");
          }else{
            tempLayoutName = tempLayoutName.replace("dsf." , "dsfmobile");
            tempLayoutName = tempLayoutName.replace(/\./g , "");
          }
          this.pageLayoutData.push({
            viewKey: tempLayoutName,
            content: JSON.parse(layoutData[item].content),
            valueKey: item,
            id: layoutData[item].id,
          });
        }
      });
      console.log(this.viewData);
      let componentsObject = this.getComponentsMap();
      console.log(componentsObject);
    },
    isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }else{
          return false;
      }
    },
    getComponentsMap(){
      let componentsMap = $components || {};
      let resultObject = {};
      Object.keys(componentsMap).forEach(moduleKey =>{
        let tempItem = componentsMap[moduleKey] || {};
        Object.keys(tempItem).forEach(componentKey =>{
          let componentItem = tempItem[componentKey];
          if(componentItem.ctrlType && componentItem.ctrlType.length > 0){
            let tempKey = componentItem.ctrlType.replace(/\./g , "");
            resultObject[tempKey] = componentKey;
          }
        });
      });
      return resultObject;
    },
  },
});
</script>